<ul class="c-icon-tooltip-list">
  <!-- [手荷物] -->
  <li *ngIf="isBaggage" class="c-icon-tooltip-list__item js-tooltip">
    <!-- [有効] -->
    <ng-container *ngIf="isValid; else invalidBaggage">
      <!-- [差分なし] -->
      <ng-container *ngIf="!diffBaggage; else baggageDiff">
        <button
          id="plan-list-plan-information-baggage-button-1"
          class="js-tooltip-btn"
          aria-controls="tooltip10"
          aria-expanded="false"
        >
          <img
            src="assets/images/icon_service_baggage_primary_64.svg"
            width="24"
            height="24"
            alt="{{ 'alt.baggage' | staticMsg }}"
          />
        </button>
      </ng-container>
      <!-- [//差分なし] -->

      <!-- [差分強調] -->
      <ng-template #baggageDiff>
        <li class="diffBase">
          <button
            id="plan-list-plan-information-baggage-button-2"
            class="js-tooltip-btn diff"
            aria-controls="tooltip13"
            aria-expanded="false"
          >
            <img
              src="assets/images/icon_service_baggage_gray_64.svg"
              width="24"
              height="24"
              alt="{{ 'alt.baggage' | staticMsg }}"
            />
          </button>
        </li>
        <li class="diffBadge">
          <img
            src="assets/images/icon_circle_primary_20.svg"
            width="24"
            height="24"
            alt="{{ 'alt.diffIcon' | staticMsg }}"
          />
        </li>
      </ng-template>
      <!-- [//差分強調] -->
    </ng-container>
    <!-- [//有効] -->

    <!-- [無効] -->
    <ng-template #invalidBaggage>
      <button
        id="plan-list-plan-information-baggage-button-3"
        class="js-tooltip-btn"
        aria-controls="tooltip10"
        aria-expanded="false"
      >
        <img
          src="assets/images/icon_service_baggage_gray_64.svg"
          width="24"
          height="24"
          alt="{{ 'alt.baggage' | staticMsg }}"
        />
      </button>
    </ng-template>
    <!-- [//無効] -->
  </li>
  <!-- [//手荷物] -->

  <!-- [ラウンジ] -->
  <li *ngIf="isLounge" class="c-icon-tooltip-list__item js-tooltip">
    <!-- [有効] -->
    <ng-container *ngIf="isValid; else invalidLounge">
      <!-- [差分なし] -->
      <ng-container *ngIf="!diffLounge; else loungeDiff">
        <button
          id="plan-list-plan-information-lounge-button-1"
          class="js-tooltip-btn"
          aria-controls="tooltip13"
          aria-expanded="false"
        >
          <img
            src="assets/images/icon_service_lounge_primary_64.svg"
            width="24"
            height="24"
            alt="{{ 'alt.lounge' | staticMsg }}"
          />
          <span class="u-visually-hidden" [innerHTML]="'alt.lounge' | staticMsg"></span>
        </button>
      </ng-container>
      <!-- [//差分なし] -->

      <!-- [差分強調] -->
      <ng-template #loungeDiff>
        <li class="diffBase">
          <button
            id="plan-list-plan-information-lounge-button-2"
            class="js-tooltip-btn diff"
            aria-controls="tooltip13"
            aria-expanded="false"
          >
            <img
              src="assets/images/icon_service_lounge_gray_64.svg"
              width="24"
              height="24"
              alt="{{ 'alt.lounge' | staticMsg }}"
            />
          </button>
        </li>
        <li class="diffBadge">
          <img
            src="assets/images/icon_circle_primary_20.svg"
            width="24"
            height="24"
            alt="{{ 'alt.diffIcon' | staticMsg }}"
          />
        </li>
      </ng-template>
      <!-- [//差分強調] -->
    </ng-container>
    <!-- [//有効] -->

    <!-- [無効] -->
    <ng-template #invalidLounge>
      <button
        id="plan-list-plan-information-lounge-button-3"
        class="js-tooltip-btn"
        aria-controls="tooltip13"
        aria-expanded="false"
      >
        <img
          src="assets/images/icon_service_lounge_gray_64.svg"
          width="24"
          height="24"
          alt="{{ 'alt.lounge' | staticMsg }}"
        />
      </button>
    </ng-template>
    <!-- [//無効] -->
  </li>
  <!-- [//ラウンジ] -->

  <!-- [機内食] -->
  <li *ngIf="isMeal" class="c-icon-tooltip-list__item js-tooltip">
    <!-- [有効] -->
    <ng-container *ngIf="isValid; else invalidMeal">
      <!-- [差分なし] -->
      <ng-container *ngIf="!diffMeal; else mealDiff">
        <button
          id="plan-list-plan-information-meal-button-1"
          class="js-tooltip-btn"
          aria-controls="tooltip08"
          aria-expanded="false"
        >
          <img src="assets/images/icon_meal_primary_28.svg" width="24" height="24" alt="{{ 'alt.food' | staticMsg }}" />
          <span class="u-visually-hidden" [innerHTML]="'alt.food' | staticMsg"></span>
        </button>
      </ng-container>
      <!-- [//差分なし] -->

      <!-- [差分強調] -->
      <ng-template #mealDiff>
        <li class="diffBase">
          <button
            id="plan-list-plan-information-meal-button-2"
            class="js-tooltip-btn diff"
            aria-controls="tooltip13"
            aria-expanded="false"
          >
            <img src="assets/images/icon_meal_gray_28.svg" width="24" height="24" alt="{{ 'alt.food' | staticMsg }}" />
          </button>
        </li>
        <li class="diffBadge">
          <img
            src="assets/images/icon_circle_primary_20.svg"
            width="24"
            height="24"
            alt="{{ 'alt.diffIcon' | staticMsg }}"
          />
        </li>
      </ng-template>
      <!-- [//差分強調] -->
    </ng-container>

    <!-- [無効] -->
    <ng-template #invalidMeal>
      <button
        id="plan-list-plan-information-meal-button-3"
        class="js-tooltip-btn"
        aria-controls="tooltip08"
        aria-expanded="false"
      >
        <img src="assets/images/icon_meal_gray_28.svg" width="24" height="24" alt="{{ 'alt.food' | staticMsg }}" />
      </button>
    </ng-template>
    <!-- [//無効] -->
  </li>
  <!-- [//機内食] -->
</ul>
